import { useMutation } from "react-query";
import { axiosInstance } from "../../../libs/axiosConfig";

export const mutateBlob = (path: string) => {
	return useMutation({
		mutationKey: [path],
		mutationFn: async () => {
			return await axiosInstance
				.get(path, {
					responseType: 'blob',
					headers: {
						'Content-Type': 'application/octet-stream',
					},
				})
				.then((res) => new Blob([res.data]));
		},
	});
};
